import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon/Icon';

import './NotMemberPlaceholder.css';

const NotMemberPlaceholder = ({ message }) => {
  return (
    <div styleName="placeholderContainer">
      <Icon
        size="4x"
        style={{ color: '#999999', margin: '0 0 15px 0' }}
        icon={['fal', 'comments']}
      />
      <span styleName="placeholderMessage">{message || ''}</span>
    </div>
  );
};

NotMemberPlaceholder.propTypes = {
  message: PropTypes.string
};

NotMemberPlaceholder.defaultProps = {
  message: null
};
export default NotMemberPlaceholder;
